<ion-content>
  <div class="login-container">
    <ion-button class="back-btn" ion-button (click)="cancel()" icon-left>
      <div class="button-inner">
        <ion-icon name="arrow-back"></ion-icon>
        Back
      </div>
    </ion-button>
    <div class="login-box">
      <div class="loading-container" *ngIf="loading">
        <ion-spinner></ion-spinner>
        <p>Loading sign in...</p>
      </div>
      <div id="clerk-signin" [hidden]="loading"></div>
    </div>
  </div>
  <div class="triangleBg"></div>
</ion-content>